// extracted by mini-css-extract-plugin
export default {"logo":"src_logo__49xUk","logosContainer":"src_logosContainer__+FGHS"};